import {
  Tabs,
  Tab,
  Paper,
  Stack,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import SurveyQuestionDetails from "components/survey/questions/SurveyQuestionDetails";
import { useState } from "react";
import ctaBackIconBlack from "assets/images/common/ctaBackIconBlack.svg";
const SurveyQuestionDetailsPage = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("details");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      spacing={2}>
      <Stack sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            className="animate__animated animate__fadeIn dt-ta-nav-page-info-tbtns-title1"
            src={ctaBackIconBlack}
            alt="add"
            onClick={() => navigate(-1)}
          />
          <p style={{ color: "#101828", fontSize: "18px", fontWeight: 600 }}>
            Survey Question Details
          </p>
        </Box>
        <Tabs
          className="dt-ta-nav-page-info-tbtns-tabs"
          value={activeTab}
          onChange={(e, newValue) => handleTabChange(e, newValue)}
          aria-label="Question-Detail">
          <Tab
            sx={{ textTransform: "capitalize" }}
            value="details"
            label="Details"
          />

          <Button
            startIcon={
              <img
                src="/images/survey/edit-white.svg"
                alt="edit survey module"
              />
            }
            onClick={() =>
              navigate(`/programs/survey-questions/${params.questionId}/edit`)
            }
            sx={{ position: "absolute", right: 0 }}
            variant="contained">
            <Typography
              component="span"
              sx={{
                color: "#FFF",
                fontWeight: 700,
                textTransform: "capitalize",
              }}>
              Edit
            </Typography>
          </Button>
        </Tabs>
        <Paper sx={{ marginBlock: "1.375rem" }} elevation={0}>
          {activeTab === "details" && <SurveyQuestionDetails />}
        </Paper>
      </Stack>
    </Stack>
  );
};
export default SurveyQuestionDetailsPage;
